import script from "./spinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./spinner.vue?vue&type=script&lang=ts&setup=true"

import "./spinner.vue?vue&type=style&index=0&id=df7959d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df7959d8"]])

export default __exports__